import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFlowElements } from "../../../actions/taskSidebar";
import { icon, label, number, tooltip } from "../../../config";
import { FlowElementCommandCell } from "../../../shared/components/FlowElement/FlowElementCommandCell";
import { getActiveMemberVariables } from "../../../shared/services/workflow.services";
import { GridContext } from "../../../utils/kendo";
import { getDD4List } from "../../TaskSidebar/TaskSidebarContent/Details/taskDetail.helper";
import { getAssigneeData, handleGetProjectWorkflows } from "../../TaskSidebar/sidebar.helper";
import "../WorflowDesigner.scss";
import { deleteItem, handleWorkflowAssignment } from "../workflowHelper";
import { FlowElementsContext } from "./FlowElementsContextProvider";
import { useFlowElementHandlers } from "./flowElementscommonHook";

/**
 * Parent Component : FLowElementDetails
 * This is the simplified view for flow elements ( for task only )
 * Childen : FlowElementCommandCell
 * @author Sarthak Arora
 */
const SimplifiedFlowElementDetails = (props) => {
  const { task, flowElements } = useSelector((state) => state.taskSidebar);
  const { defaultDetails } = useSelector((state) => state.tasks);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { handleApprovalFlow, handleFlowLock, showTooltip, hideTooltip } = useFlowElementHandlers();
  const { flowElementData, deleteFlowElement, entity } = useContext(GridContext);
  const {
    flowAssignmentType,
    setFlowAssignmentType,
    flowWorkflowAssignmentType,
    setFlowWorkflowAssignmentType,
    flowTaskAssignmentId,
    setFlowTaskAssignmentId,
    flowWorkflowAssignmentId,
    setFlowWorkflowAssignmentId,
    isApproval,
    isFlowLocked,
    wrapper,
    taskAssignmentTypes,
    workflowAssignmentTypes,
    setIsApproval,
  } = useContext(FlowElementsContext);
  const [activeMemberVariables, setActiveMemberVariables] = useState([]);
  const [selectedActiveMember, setSelectedActiveMember] = useState(null);
  useEffect(() => {
    const requiredAssignType = taskAssignmentTypes?.find((c) => c.value === props?.dataItem?.taskAssignmentType);
    setFlowAssignmentType(requiredAssignType ? requiredAssignType : null);
  }, [flowAssignmentType, taskAssignmentTypes, flowElementData]);

  /**
   * sets flow assignment Id for new and existing flow element
   * flowAssignment type:-
   * two for user assignment
   * three for project assignment
   */
  useEffect(() => {
    switch (props?.dataItem?.taskAssignmentType) {
      case number.TWO:
        const requiredUserAssignId = defaultDetails?.assigneeList?.find((c) => c.value === props?.dataItem?.taskAssignmentId);
        if (requiredUserAssignId) requiredUserAssignId.AssignmentType = 2;
        setFlowTaskAssignmentId(requiredUserAssignId ? requiredUserAssignId : null);
        break;
      case number.THREE:
        const allProjectList = _.orderBy([...defaultDetails?.allProjectsList], [(project) => project.label?.toLowerCase()?.trim()], ["asc"]);
        let requiredProjectAssignId = allProjectList?.find((c) => c.value === props?.dataItem?.taskAssignmentId);
        if (requiredProjectAssignId) requiredProjectAssignId.AssignmentType = 3;
        setFlowTaskAssignmentId(requiredProjectAssignId ? requiredProjectAssignId : null);
        break;
      default:
        break;
    }
  }, [props?.dataItem?.taskAssignmentId, props?.dataItem?.taskAssignmentType, flowAssignmentType, defaultDetails]);

  /**
   * sets workflow assignment type for new and existing flow element
   */
  useEffect(() => {
    const requiredWorkflowAssignType = workflowAssignmentTypes?.find((c) => c.value === props?.dataItem?.workflowAssignmentType);
    setFlowWorkflowAssignmentType(requiredWorkflowAssignType);
  }, [props?.dataItem.workflowAssignmentType, workflowAssignmentTypes]);

  /**
   * sets workflowAssignmentId (relatedAssignedId ) for new and existing flow element
   */
  useEffect(() => {
    (async () => {
      const payload = { assignedId: flowTaskAssignmentId, defaultDetails };
      let relatedAssignedIdList = await getDD4List(payload);
      const requiredWorkflowAssignmentId = relatedAssignedIdList?.find((item) => item.value === props?.dataItem?.workflowAssignmentId);

      switch (props?.dataItem?.workflowAssignmentType) {
        case number.TWO:
          if (props?.dataItem?.workflowAssignmentId) {
            setFlowWorkflowAssignmentId(requiredWorkflowAssignmentId || null);
          } else {
            handleWorkflowAssignment(
              flowTaskAssignmentId,
              flowTaskAssignmentId?.AssignmentType,
              setFlowWorkflowAssignmentType,
              setFlowWorkflowAssignmentId,
              flowWorkflowAssignmentId
            );
          }
          break;
        case number.FIVE:
          setFlowWorkflowAssignmentId(requiredWorkflowAssignmentId || relatedAssignedIdList?.[number.ZERO]);
          break;
        default:
          break;
      }
    })();
  }, [props?.dataItem?.workflowAssignmentId, defaultDetails, flowWorkflowAssignmentType, flowTaskAssignmentId]);

  /**
   * sets isApproval to true if worflow element is in approval
   */
  useEffect(() => {
    setIsApproval(props?.dataItem?.isApproval);
  }, [props?.dataItem?.isApproval]);

 

  useEffect(() => {
    if (props.dataItem.flowElementType === number.TWO) {
      getActiveMemberVariables({ companyId: user.companyId }).then((res) => {
        setActiveMemberVariables(res);
        let selectedActiveMember = res?.find((item) => item._id === props?.dataItem?.variableId);
        setSelectedActiveMember(selectedActiveMember || res?.[number.ZERO]);
      });
    }
  }, [user.companyId , props?.dataItem?.variableId]);

  

  /**handles deletion of existing flow element*/
  const handleDeleteFlowElement = async (dataItem) => {
    let payload = {
      flowElementId: dataItem?.id,
    };
    payload["taskId"] = entity;
    dispatch(setFlowElements([...deleteItem(dataItem, [...flowElements])]));
    entity && (await deleteFlowElement(payload));
  };

  return (
    <div>
      <div className={`workflow-grid-border position-relative`}>
        <div className={`${isApproval ? "border border-primary p-2" : "border border-secondary p-2"}`}>
          <div className={`row`}>
            {props.dataItem.flowElementType === number.TWO ? (
              <>
                <div className={`col-md-5`}>
                  <div className='d-flex align-items-center'>
                    <label className='mr-2 mb-0'>{label.DYNAMIC} Assignment:</label>
                    <span>{selectedActiveMember?.name}</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='col-md-5 d-flex align-items-center'>
                  {flowTaskAssignmentId?.AssignmentType === number.TWO ? (
                    <>
                      <div className='image-box mr-2'>
                        {flowTaskAssignmentId?.PhotoLinks?.small ? (
                          <img src={flowTaskAssignmentId?.PhotoLinks?.small} className='profile-picture rounded-circle' alt={flowTaskAssignmentId?.label} />
                        ) : (
                          <span className='assignee-icon'>{icon.USER_ICON}</span>
                        )}
                      </div>
                      <div className='text-truncate'>{flowTaskAssignmentId?.label}</div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`image-box mr-2 ${
                          flowTaskAssignmentId?.Privacy == number.ONE
                            ? "black-icon"
                            : flowTaskAssignmentId?.Privacy == number.TWO
                            ? "sky-blue-icon"
                            : flowTaskAssignmentId?.Privacy == number.THREE
                            ? "maroon"
                            : flowTaskAssignmentId?.Privacy == number.FOUR
                            ? "sky-blue-icon"
                            : "black-icon"
                        }`}>
                        {icon.PROJECT_ICON}
                      </div>
                      <div className='text-truncate'>{flowTaskAssignmentId?.label}</div>
                    </>
                  )}
                </div>
                {flowAssignmentType && flowTaskAssignmentId && (
                  <>
                    <div className={`form-group col-md-1 d-flex align-item-end justify-content-center`}>
                      {<span>{icon[flowWorkflowAssignmentType?.icon]}</span>}
                    </div>
                    <div className='form-group col-md-4'>
                      <span title={flowWorkflowAssignmentId?.label}></span>
                      {<div className='text-truncate'>{flowWorkflowAssignmentId?.label || label.UNASSIGNED}</div>}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <div className={`form-row custom-form-row`}>
            <div className={`form-group col-md-1 workflow-approval-column `}>
              <button
                id='approval-btn'
                className={`approval-icon mt-2 ml-3 d-block ${isApproval ? "text-blue" : "icon-black"} border-none`}
                title={tooltip.SEEK_APPROVAL}
                onClick={handleApprovalFlow}
                disabled={true}>
                {!isApproval ? "" : icon?.APPROVAL_ICON}
              </button>
            </div>
            <div className={`form-group col-md-6 workflow-lock-task-column`}>
              <button
                id='simplified-flow-element-lock-button'
                ref={wrapper}
                className={`flow-lock-icon mt-2 ml-3 d-block ${isFlowLocked ? "text-blue" : "icon-black"} border-none `}
                title={isFlowLocked ? tooltip.LOCKED_ON_COMPLETION : tooltip.LOCK_TASK}
                onClick={handleFlowLock}
                disabled={true}
                onMouseOver={showTooltip}
                onMouseLeave={hideTooltip}>
                {isFlowLocked ? icon.APPROVAL_LOCK : ""}
              </button>
            </div>
            <div className={`form-group col-md-3`}></div>
            <div className='form-group col-md-2 d-flex align-items-center '>
              <span className={` mt-2 col-md-3 flow-element-grid-action`}>
                <FlowElementCommandCell {...props} handleDeleteFlowElement={handleDeleteFlowElement} />
              </span>
            </div>
          </div>
          {!task?.taskId && !!isApproval && (
            <span className='approval-border-icon' title={tooltip.APPROVAL}>
              {icon.APPROVAL_ICON}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimplifiedFlowElementDetails;
